/**
 * Toggles hidden attribute on HTML elements
 */
export var toggleHidden = function (element, shouldHide) {
    if (shouldHide) {
        element.setAttribute('hidden', 'hidden');
    }
    else {
        element.removeAttribute('hidden');
    }
};
/**
 * Converts metres to miles
 */
export var metresToMiles = function (meters) {
    return meters * 0.000621371;
};
/**
 * Constructs HWT URL
 */
export var constructHwtURL = function (_a) {
    var search = _a.search, locationType = _a.locationType, locationId = _a.locationId, destination = _a.destination, region = _a.region, resort = _a.resort, accommodation = _a.accommodation, accommodationId = _a.accommodationId, tripType = _a.tripType, departureDateType = _a.departureDateType, departureDate = _a.departureDate, departurePoints = _a.departurePoints, duration = _a.duration, boards = _a.boards, ratings = _a.ratings;
    var base = 'https://booking.haystravel.co.uk';
    var path = search
        ? '/search'
        : "/flight-and-hotel/".concat(destination, "/").concat(region, "/").concat(resort, "/").concat(accommodation, "/").concat(accommodationId);
    var url = new URL(base + path);
    var unset = 'unset';
    // Add shared query parameters
    if (tripType !== undefined && tripType !== null && tripType !== unset) {
        url.searchParams.append('type', tripType);
    }
    else {
        url.searchParams.append('type', '0');
    }
    if (departureDateType !== unset) {
        url.searchParams.append('departingType', departureDateType);
    }
    if (departureDate !== unset) {
        url.searchParams.append('departing', departureDate.substring(0, 10));
    }
    if (departurePoints !== undefined && departurePoints !== null && departurePoints !== unset) {
        var departurePointsArr = departurePoints.split(",");
        if (departurePointsArr.length > 0) {
            url.searchParams.append('departurePoints', departurePointsArr.join('-'));
        }
    }
    if (duration !== unset) {
        url.searchParams.append('duration', duration);
    }
    if (boards !== unset) {
        var boardsArr = JSON.parse(boards);
        if (boardsArr.length > 0) {
            url.searchParams.append('boards', boardsArr.join('-'));
        }
    }
    // Add search-specific query parameters
    if (search) {
        url.searchParams.append(locationType, locationId);
        if (ratings !== unset) {
            var ratingsArr = JSON.parse(ratings);
            if (ratingsArr.length > 0) {
                url.searchParams.append('ratings', ratingsArr.join('-'));
            }
        }
        url.searchParams.append('rooms', '2-');
        url.searchParams.append('sort', '0');
    }
    return url;
};
